<template>
    <div style="position:relative;">
        <div style="padding:5px;text-align:center;" v-if="totalPage > 1 && !hidePaging">
            <span style="text-align:center;" @click="firstPage"><span style="height:40px;line-height:30px;" class="btn btn-default glyphicon glyphicon-fast-backward"></span></span>
            <span style="text-align:center;" @click="prevPage"><span style="height:40px;line-height:30px;" class="btn btn-default glyphicon glyphicon-chevron-left"></span></span>
            <span class="" style="text-align:center;" @click="showPageEntry"><span style="height:40px;line-height:30px;" class="btn btn-default paging-display"> {{page}} /{{totalPage}} </span></span>
            <span style="text-align:center;" @click="nextPage"><span style="height:40px;line-height:30px;" class="btn btn-default glyphicon glyphicon-chevron-right"></span></span>
            <span style="text-align:center;" @click="lastPage"><span style="height:40px;line-height:30px;" class="btn btn-default glyphicon glyphicon-fast-forward"></span></span>
        </div>
        <div>
         <slot>slot content goes here</slot>
        </div>
        <div style="padding:5px;text-align:center;clear:both;" v-if="totalPage > 1 && !hidePaging">
            <span style="text-align:center;" @click="firstPage"><span style="height:40px;line-height:30px;" class="btn btn-default glyphicon glyphicon-fast-backward"></span></span>
            <span style="text-align:center;" @click="prevPage"><span style="height:40px;line-height:30px;" class="btn btn-default glyphicon glyphicon-chevron-left"></span></span>
            <span class="" style="text-align:center;" @click="showPageEntry"><span style="height:40px;line-height:30px;" class="btn btn-default paging-display"> {{page}} /{{totalPage}} </span></span>
            <span style="text-align:center;" @click="nextPage"><span style="height:40px;line-height:30px;" class="btn btn-default glyphicon glyphicon-chevron-right"></span></span>
            <span style="text-align:center;" @click="lastPage"><span style="height:40px;line-height:30px;" class="btn btn-default glyphicon glyphicon-fast-forward"></span></span>
        </div>
    </div>
</template>
<script>

    import SimplePaging from '../../utl/paging'

    export default {
        methods: {
            getRoutePage: function () {
                if (typeof this.$route === "undefined") {
                    return 1;
                }
                var rPage = this.$route.query.page;
                if (typeof rPage === "undefined") {
                    rPage = 1;
                };
                return rPage;
            },
            showPageEntry: function () {
                this.pageActions.showPageEntry();
            },
            firstPage: function () {
                this.pageActions.gotoFirstPage();
            },
            lastPage: function () {
                this.pageActions.gotoLastPage();
            },
            prevPage: function () {
                this.pageActions.prevPage();
            },
            nextPage: function () {
                this.pageActions.nextPage();
            },
            initPaging: function () {
                var that = this;
                var initPage = this.getRoutePage();
                that.pageActions = SimplePaging({
                    pageChange: function (page) {
                        that.$emit('pageChange', page);    
                    },
                    textChange: function (page, totalPage) {
                        that.page = page;
                        that.totalPage = totalPage;
                    },
                    currentPage: initPage,
                    pageSize: 1,
                    totalItemCount: 1
                });
                that.page = that.pageActions.getCurrentPage();
                that.totalPage = that.pageActions.getTotalPage();
            }
        },
        props: {
            pagingInfo: Object,
            hidePaging: { type: Boolean, default: false },
            ignoreWatchRoute: { type: Boolean, default: false }
        },
        data: function () {
            return {
                items: [],
                page: 1,
                totalPage:1,
                pageActions: null
            }
        },
        watch: {
            '$route'(to, from) {
                if (this.ignoreWatchRoute === true) return;
                this.page = this.getRoutePage();
            },
            'pagingInfo'() {
                this.pageActions.resetParams(this.pagingInfo.page, this.pagingInfo.pageSize, this.pagingInfo.count);
            }
        },
        mounted: function () {
            this.initPaging();
        },
        destroyed: function () {
            this.pageActions.destroy();
        }
    }
</script>